import colors from '../../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        copyWrapper: {
            padding: '50px 0px 50px 24px',
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                padding: '20px 12px',
            },
            width: '320px'
        },
        gridContainerCentre: {
            backgroundColor: colors[mode].secondaryBackground,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '70vh',
        },
        header: {
            alignItems: 'center',
            display: 'flex',
            marginBottom: theme.spacing(4),
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
            }
        },
        illustrationImage: {
            width: '168px'
        },
        registrationRoot: {
            display: 'flex',
            justifyContent: 'center',
            padding: theme.spacing(12, 4, 4, 4),
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center',
                paddingTop: '135px',
            }
        },
        returnButton: {
            '&.MuiButton-contained': {
                '&:focus': {
                    backgroundColor: '#E5C901',
                    boxShadow: 'none'
                },
                '&:hover': {
                    backgroundColor: '#E5C901',
                    boxShadow: 'none'
                },
                alignItems: 'center',
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                color: '#003168',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 0,
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
                justifyContent: 'center',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                order: 2,
                textTransform: 'uppercase'
            }
        },
        title: {
            color: colors[mode].errorTitle,
            fontFamily :'RBCDisplay Regular',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '32px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '-0.5px',
            lineHeight: 'var(--4, 32px)',
            marginBottom: '8px'
        },
        verbiage: {
            color: colors[mode].errorVerbiage,
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingBottom: '20px',
            paddingTop: '11px',
            textAlign: 'justify',
            whiteSpace: 'pre-line',
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.75rem'
            }
        }
    }
}

export default styles